import { render, staticRenderFns } from "./readingInstructions.vue?vue&type=template&id=9f30f43a&scoped=true&lang=pug"
import script from "./readingInstructions.vue?vue&type=script&lang=ts"
export * from "./readingInstructions.vue?vue&type=script&lang=ts"
import style0 from "./readingInstructions.vue?vue&type=style&index=0&id=9f30f43a&prod&lang=stylus&scoped=true"
import style1 from "./readingInstructions.vue?vue&type=style&index=1&id=9f30f43a&prod&lang=stylus&scoped=true"
import style2 from "./readingInstructions.vue?vue&type=style&index=2&id=9f30f43a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f30f43a",
  null
  
)

export default component.exports